export default __webpack_public_path__ + "static/media/1-1.df512864.jpg";